import {decodeToken} from "react-jwt";
class User {
    static #userid = null;
    static #username = null;
    static #role = null;
    static #authenticated = false;
    static #gender = null;
    static #authProvider = null;
    static #merged = null;
    static #fullName = null;
    static #isAdmin = null;
    static #impersonatedBy = undefined; // undefined = not yet decoded
    static #mustSelectAccount = undefined; // undefined = not yet decoded

    static removeToken() {
        localStorage.removeItem('jwt');
    }

    static logout() {
        this.removeToken();
    }

    static decodeToken(token) {
        let payload = decodeToken(token);
        if(payload === null) {
            window.location = process.env.PUBLIC_URL + "/login"
            return;
        }
        this.#userid = payload.id;
        this.#username = payload.username;
        this.#gender = payload.gender
        this.#role = payload.role;
        this.#authProvider = payload.authProvider || 'local';
        this.#merged = payload.merged || false;
        this.#fullName = payload.fullName || null;
        this.#isAdmin = payload.isAdmin || false;
        this.#impersonatedBy = payload.impersonatedBy || null;
        this.#mustSelectAccount = payload.mustSelectAccount || false;
        this.#authenticated = true;
        return;
    };

    static saveToken(token) {
        localStorage['jwt'] = token;
        this.decodeToken(token);
        return;
    }

    static getToken() {
        return localStorage['jwt'];
    }

    static getUserID() {
        if (this.#userid === null) {
            this.decodeToken(localStorage['jwt']);
        }
        return this.#userid;
    };

    /**
     * Liefert Benutzernamen des derzeit angemeldeten Benutzers, ansonsten null
     * @return {name} Benutzernamen des Benutzers
     */
    static getUsername() {
        if (this.#username === null) {
            this.decodeToken(localStorage['jwt']);
        }
        return this.#username;
    };

    /**
     * Liefert den vollen Namen (U_FullName) des angemeldeten Benutzers,
     * faellt auf den Benutzernamen zurueck, falls kein voller Name vorhanden ist
     * @return {string} Voller Name oder Benutzername
     */
    static getFullName() {
        if (this.#username === null) {
            this.decodeToken(localStorage['jwt']);
        }
        return this.#fullName || this.#username;
    };

    /**
     * Liefert Rolle des derzeit angemeldeten Benutzers, ansonsten null
     * @return {rolle} Rolle des Benutzers
     */
    static getRole() {
        if (this.#role === null) {
            this.decodeToken(localStorage['jwt']);
        }
        return this.#role;
    };


    /**
     * Liefert Boolean zurück, der anzeigt, ob Benutzer angemeldet ist
     * @return {boolean} true falls Benutzer angemeldet ist, ansonsten false
     */
    static isAuthenticated() {
        var token = this.getToken();
        if(token) {
            var params = decodeToken(token);
            return Math.round(new Date().getTime() / 1000) <= params.exp;
        } else {
            return false;
        }
    };

    static isAdmin() {
        if (this.#isAdmin === null) {
            this.decodeToken(localStorage['jwt']);
        }
        return this.#isAdmin;
    }

    static getHomepage() {
        let route = '';
        if(this.#role != null) {
            if (this.#role === 'Verwalter') {
                route = '/application';
            } else {
                route = '/start';
            }
        }
        return route;
    };

    static getGender() {
        if (this.#gender === null) {
            decodeToken(localStorage['jwt']);
        }
        return this.#gender;
    }

    static getAuthProvider() {
        if (this.#authProvider === null) {
            this.decodeToken(localStorage['jwt']);
        }
        return this.#authProvider;
    }

    static getDisplayName() {
        if (this.#authProvider === null) {
            this.decodeToken(localStorage['jwt']);
        }
        if (this.#authProvider === 'entraid' && this.#fullName) {
            return this.#fullName;
        }
        return this.#username;
    }

    static isMerged() {
        if (this.#merged === null) {
            this.decodeToken(localStorage['jwt']);
        }
        return this.#merged;
    }

    static isImpersonating() {
        if (this.#impersonatedBy === undefined) {
            this.decodeToken(localStorage['jwt']);
        }
        return !!this.#impersonatedBy;
    }

    static getImpersonatedBy() {
        if (this.#impersonatedBy === undefined) {
            this.decodeToken(localStorage['jwt']);
        }
        return this.#impersonatedBy;
    }

    /**
     * True, wenn der Benutzer User-Relationen hat und daher zwingend eines
     * seiner Ziel-Konten uebernehmen muss, statt selbst zu arbeiten.
     */
    static mustSelectAccount() {
        if (this.#mustSelectAccount === undefined) {
            this.decodeToken(localStorage['jwt']);
        }
        return !!this.#mustSelectAccount;
    }

    /**
     * True, wenn die aktuelle Sitzung ueber eine User-Relation laeuft
     * (Kontoverbund) und nicht ueber eine Admin-Impersonierung.
     */
    static isRelationImpersonation() {
        const via = this.getImpersonatedBy();
        return !!(via && via.viaRelation);
    }

    /**
     * Kontowechsel im Kontoverbund. Parkt — anders als startImpersonation —
     * bewusst kein Token: der Hub-User darf nie zu sich selbst zurueckkehren,
     * und ein zweiter Wechsel wuerde das geparkte Token ueberschreiben.
     * Der Rueckweg laeuft ueber die Kontoauswahl, die den Hub aus dem
     * impersonatedBy-Claim des aktuellen Tokens ableitet.
     */
    static switchAccount(accountToken) {
        this.#impersonatedBy = undefined; // force re-decode after token swap
        this.#mustSelectAccount = undefined;
        this.saveToken(accountToken);
    }

    static startImpersonation(impersonationToken) {
        localStorage['jwt_admin'] = localStorage['jwt'];
        this.#impersonatedBy = undefined; // force re-decode after token swap
        this.#mustSelectAccount = undefined;
        this.saveToken(impersonationToken);
    }

    static stopImpersonation() {
        const adminToken = localStorage['jwt_admin'];
        if (!adminToken) return false;
        localStorage.removeItem('jwt_admin');
        this.#impersonatedBy = undefined;
        this.#mustSelectAccount = undefined;
        this.saveToken(adminToken);
        return true;
    }
}

export default User;
